import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faItalic } from '@fortawesome/pro-light-svg-icons';

export type ProLightItalicProps = IconComponentProps;

export const ProLightItalic = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightItalicProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faItalic}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faItalic}
    />
  );
};

ProLightItalic.displayName = 'ProLightItalic';
